import { STEP_NAME_PATH } from "../../navigation/params";
import { actionTypes } from "./stepper.actions";

export interface IStepState {
  activeStep: number;
  stepName: string;
}

const initialState: IStepState = {
  activeStep: 0,
  stepName: STEP_NAME_PATH.ONBOARDING_SELECT,
};

export const stepperReducer = (
  state: IStepState = initialState,
  action: { type: string, payload: IStepState },
) => {
  switch (action.type) {
  case actionTypes.SET_STEPPER:
    return {
      ...state,
      activeStep: action.payload.activeStep,
      stepName: action.payload.stepName,
    };
  default:
    return state;
  }
};
